const PropTypes = require('prop-types')
const isLoggedIn = require('module/viewer/helpers/is_logged_in')
const hasFeature = require('module/user/helpers/has_feature')

// component which renders children if the viewer is logged in and premium
function ProComponent({ children }, { viewer }) {
    if (! isLoggedIn(viewer)) return null
    if (! hasFeature(viewer, 'upgrade')) return null
    return children
}
ProComponent.propTypes = {
    children: PropTypes.any,
}
ProComponent.contextTypes = {
    viewer: PropTypes.object.isRequired,
}

module.exports = {
    ProComponent,
}
